const PROFILE = {
  ABOUT: 'about',
  STATISTIC: 'statistic',
  QUESTIONS: 'questions',
  NOTIFICATIONS: 'notifications',
  REVIEWS: 'reviews',
};

export default PROFILE;
